<template lang="pug">
  div.app-base
    template
      navigation-bar

      v-main
        v-container.py-5.px-6(fluid)
          tool-bar.mb-6

          v-card.base-view.pa-6
            .loading-overlay(v-if="isLoading")
              v-progress-circular(:size="60" color="#666" indeterminate)

            router-view

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'

@Component({
  components: {
    NavigationBar: () => import('@/components/navigation-bar'),
    ToolBar: () => import('@/components/tool-bar'),
  },

  computed: mapGetters([
    'isLoading',
    'sidebarVisible'
  ]),

  methods: mapActions([
    'loadAgencies',
    'loadCompanies',
  ])
})
export default class Base extends Vue {
  mounted () {
    this.$nextTick(() => {
      this.loadAgencies()
        .then(() => {
          this.loadCompanies()
        })
    })
  }
}
</script>

<style lang="sass">
.app-base
  min-height: 100vh

  .base-view
    min-height: calc(100vh - 104px)

    .loading-overlay
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
      z-index: 99

      .v-progress-circular
        position: fixed
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

      &.fixed
        position: fixed
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        background-color: rgba(0, 0, 0, 0.5)
        color: #eee

        .v-progress-circular
          position: relative
          top: 0
          left: 0
          transform: none
</style>
